export default "__VITE_ASSET__of7oIhJY__"